/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GoogleMap = function () {
  function GoogleMap() {
    _classCallCheck(this, GoogleMap);
    this.locationThumbnailContainer = document.querySelector('.location-map-thumbnail');
  }
  return _createClass(GoogleMap, [{
    key: "getThumbnail",
    value: function getThumbnail() {
      if (this.locationThumbnailContainer) {
        var line1 = document.querySelector('.address-line-1');
        var line2 = document.querySelector('.address-line-2');
        var line3 = document.querySelector('.address-line-3');
        var address = '';
        if (line1) {
          address += "".concat(line1.innerText.replace(/ /g, '+'));
        }
        if (line2) {
          address += "".concat(line2.innerText.replace(/ /g, '+'));
        }
        if (line3) {
          address += line3.innerText.replace(/ /g, '+').replace(',', '');
        }
        if (address) {
          var iframe = "<iframe\n          style=\"position:absolute;top:0;left:0;width:100%;height:100%;border:0;\"\n          loading=\"lazy\"\n          allowfullscreen\n          referrerpolicy=\"no-referrer-when-downgrade\"\n          src=\"https://www.google.com/maps/embed/v1/place?key=AIzaSyB_-JON1px4G3i047DSm_A3YX6DJzGlXpY\n          &q=".concat(address, "\">\n        </iframe>");
          this.locationThumbnailContainer.innerHTML = iframe;
        }
      }
    }
  }]);
}();
export { GoogleMap as default };
(function () {
  var googleMap = new GoogleMap();
  googleMap.getThumbnail();
})(Drupal);